import '@things-factory/auth-base' // for ResolverContext

import { Arg, Ctx, Query, Root } from 'type-graphql'

import { ScalarAny, ScalarObject } from '@things-factory/shell'

import { AthenaController } from '../../controllers'

const athenaClient = new AthenaController()

export class AthenaQuery {
  @Query(returns => ScalarAny, { description: 'To query data in S3 using Amazon Athena SDK' })
  async queryFromAthena(
    @Root() _,
    @Arg('queryData', type => ScalarObject) queryData: any,
    @Ctx() context: ResolverContext
  ): Promise<any> {
    const { domain, user } = context.state

    var queryResult = await athenaClient.query(queryData)

    return queryResult
  }
}
